import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { DialogProps } from "src/utils";

const SimpleDialog: React.FC<DialogProps> = ({
  open,
  title,
  message,
  setOpen,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <MuiDialog className="dialog" open={open} onClose={handleClose}>
      <DialogTitle className="title">{title}</DialogTitle>

      <DialogContent className="body">{message}</DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Aceptar</Button>
      </DialogActions>
    </MuiDialog>
  );
};

export default SimpleDialog;
